import styled from 'styled-components/macro';

const AccordionStyled = styled.div.attrs({ className: 'Accordion' })`
  max-height: ${({ maxHeight }) => `${maxHeight}px`};
  overflow: hidden;
  transition: all 1s;
`;

export default AccordionStyled;
